import { BaseAPIState, Value } from '@philips-emr/tws-core';
import { EventData, EventListener } from '@philips-emr/tws-core/lib/component/event';
import { Mountable } from '@philips-emr/tws-core/lib/component/types';

enum Layout {
  SIMPLE = 'Simple',
  CARD = 'Card',
}

interface PropCustom extends BaseAPIState {
  endpoint: string;
  data: Record<string, Value>;
  visible: boolean;
  parameters: Record<string, Value>;
  hasTitleAction: boolean;
}

interface ParamAction {
  endpoint?: string;
  parameters?: Record<string, Value>;
}

class HpmsCustomContentCollapseArgs<T> {
  onOpenRender: ActionRenderType;
  data: T;
}

type ActionRenderType = (event: ParamAction) => void;

class HpmsCustomContentCollapseEvent<T> extends EventData<HpmsCustomContentCollapseEventType<T>> implements HpmsCustomContentCollapseArgs<T> {
  data: T;
  onOpenRender: ActionRenderType;

  constructor({ data, onOpenRender }: HpmsCustomContentCollapseArgs<T>) {
    super();

    this.data = data;
    this.onOpenRender = onOpenRender;
  }
}

interface HpmsCustomContentCollapseEventType<T> extends Mountable {

  /** @event */
  onOpenCollapse: HpmsCustomContentCollapseEventListener<T>;

}

class HpmsCustomContentCollapseEventListener<T> extends EventListener<HpmsCustomContentCollapseEventType<T>, HpmsCustomContentCollapseEvent<T>, HpmsCustomContentCollapseArgs<T>> {
  constructor() {
    super(HpmsCustomContentCollapseEvent);
  }
}
export {
  HpmsCustomContentCollapseEventListener,
  HpmsCustomContentCollapseEventType,
  HpmsCustomContentCollapseEvent,
  ActionRenderType,
  ParamAction,
  HpmsCustomContentCollapseArgs,
  PropCustom,
  Layout,
};
